import React, { useState, FunctionComponent, useEffect, useRef } from 'react';
import { Presentation } from './presentation';
import type { Occupation } from '../../../types/toppage';
import type { OccupationDetail } from '../../../types/toppage';
import { getOccupations } from '../../../services/toppage';
import { getOccupationDetails } from '../../../services/toppage';

export const Component: FunctionComponent = () => {
  const [occupations, setOccupations] = useState<Occupation[]>([]);
  const [occupationDetails, setOccupationDetails] = useState<OccupationDetail[]>([]);
  const detailsRef = useRef<HTMLDetailsElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);  

  useEffect(() => {
    const request = async () => {
      try {
        const occupationsResponse = await getOccupations();
        setOccupations(occupationsResponse || []);
        const occupationDetailsResponse = await getOccupationDetails();
        setOccupationDetails(occupationDetailsResponse || []);
      } catch (error) {
        console.error('Failed to fetch occupation data:', error);
        setOccupations([]);
        setOccupationDetails([]);
      }
    };
    request();
  }, []);

  const onClickSummary = (e: React.MouseEvent) => {
    e.preventDefault(); // ネイティブ開閉を止める

    const details = detailsRef.current;
    const content = contentRef.current;
    if (!details || !content) return;

    const isOpen = details.hasAttribute('open');
    const duration = 300;

    // 連打対策：現在アニメ中ならリセット
    content.getAnimations().forEach((a) => a.cancel());

    if (isOpen) {
      // 閉じる
      const start = content.offsetHeight;
      const closing = content.animate(
        [
          { height: `${start}px`, opacity: 1 },
          { height: 0, opacity: 0 },
        ],
        { duration, easing: "ease" }
      );
      closing.onfinish = () => {
        details.removeAttribute('open');
        content.style.height = "";
        content.style.opacity = "";
      };
    } else {
      // 開く
      details.setAttribute('open', 'true');
      const end = content.offsetHeight;
      content.style.height = "0px";
      content.style.opacity = "0";

      const opening = content.animate(
        [
          { height: 0, opacity: 0 },
          { height: `${end}px`, opacity: 1 },
        ],
        { duration, easing: "ease" }
      );
      opening.onfinish = () => {
        content.style.height = "";
        content.style.opacity = "";
      };
    }
  };

  return (
    <Presentation
      occupations={occupations}
      occupationDetails={occupationDetails}
      detailsRef={detailsRef}
      contentRef={contentRef}
      onClickSummary={onClickSummary}
    />
  );
};